import React from 'react';

const SectionHeading = ({
  title,
  subtitle,
  centered = true,
  className = ''
}) => {
  return (
    <div className={`mb-10 ${centered ? 'text-center' : ''} ${className}`}>
      <h2 className="text-3xl md:text-4xl font-serif font-bold text-gray-900 mb-4">
        {title}
      </h2>
      <div className={`w-16 h-1 bg-primary-red ${centered ? 'mx-auto' : ''} mb-4`} />
      {subtitle && (
        <p className="text-gray-600 max-w-3xl mx-auto leading-relaxed">
          {subtitle}
        </p>
      )}
    </div>
  );
};

export default SectionHeading;
